import DomainModel from 'cio/models/domain';
import IdentityModel from 'cio/models/identity';

export type IdentityByDomain = {
  [key: string]: IdentityModel[];
};

export function groupIdentitiesByDomain(identities: IdentityModel[], domains: DomainModel[]): IdentityByDomain {
  let groups: IdentityByDomain = {};

  domains.forEach((domain) => {
    groups[domain.domain.toLowerCase()] = identities.filter((identity) => belongsToDomain(domain, identity));
  });

  return groups;
}

// Identities that _end_ in a particular domain should be grouped under
// that domain, even if they have liquid. For example:
//
// {{customer.account_manager_email}}@example.com should be grouped
// within example.com. {{customer.account_manager_email}} should be
// grouped under dynamic identities since its domain isn't known.
export function belongsToDomain(domain: DomainModel, identity: IdentityModel) {
  let key = domain.domain.toLowerCase();
  return identity.email?.toLowerCase().endsWith(`@${key}`);
}
